import React, { useEffect } from 'react'
import { observer } from 'mobx-react-lite'
import { Routes, Route, useNavigate } from 'react-router-dom'
import { useStores } from '../../../cls/stores/MobXProvider'
import { PageLoader } from '../../../components/Shared'
import RecruitmentEdit from './RecruitmentEdit'
import RecruitmentLst from './RecruitmentLst'
import {
	actLoadRecruitment,
	requireRecruitmentById
} from '../../../stores/recruitment/actions'
import { useSmartTranslation } from '../../../cls/TranslationContext'
/**
 * @component RecruitmentMain
 * @description Entry point for the recruitment module. Handles routing, permission checks, and loading logic.
 *
 * Routes:
 * - `/recruitment/` → Lists all recruitment items
 * - `/recruitment/:itmId/edit` → Edit recruitment item
 * - `/recruitment/:itmId/view` → View recruitment item (read-only)
 *
 * Access is restricted to Super Admins only.
 *
 * @returns {JSX.Element} The rendered routing structure for the recruitment module.
 */
const RecruitmentMain = () => {
	const navigate = useNavigate()
	const { t } = useSmartTranslation()

	const { users } = useStores()
	const { loggedInUserId, loggedInUser } = users
	const isSuperAdmin = loggedInUser?.isSuperAdmin
	useEffect(() => {
		if (!users.isLoggedIn) {
			navigate('/logout')
			return
		}
	}, [loggedInUserId])

	// If the user does not have personal permission
	// and lacks the required permissions for the action and resource
	// Display a message indicating lack of permissions
	if (!isSuperAdmin) {
		return (
			<div style={{ textAlign: 'center' }}>
				{t('__denied.access').charAt(0).toUpperCase() +
					t('__denied.access%__feature-off%_recruitment')
						.toLowerCase()
						.slice(1)}
			</div>
		)
	}

	return (
		<Routes>
			<Route
				path=":itmId/*"
				element={
					<PageLoader
						forceLoad={true}
						requireItm={(id) => {
							return requireRecruitmentById(id)
						}}
						loadItm={(id) => actLoadRecruitment(id)}
						targetLst="sprints"
					/>
				}
			>
				<Route path="edit" element={<RecruitmentEdit />} />
				<Route
					path="view"
					element={<RecruitmentEdit viewOnly={true} />}
				/>
			</Route>
			<Route index element={<RecruitmentLst />} />
			<Route path="*" element={<div>Not found</div>} />
		</Routes>
	)
}
export default observer(RecruitmentMain)
